module.exports = __webpack_public_path__ + "assets/img/1q.bf6879bc.png";